import React from 'react';
import { Table } from 'antd/lib';

const colums = [
  {
    title: 'Tipo Sello',
    dataIndex: ['tipo_sello', 'nombre'],
  },
  {
    title: 'Precio',
    dataIndex: ['tipo_sello', 'valor'],
    render: text =>
      text.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' }),
  },
  {
    title: 'Stock',
    dataIndex: 'cantidad',
  },
  {
    title: 'Limite',
    dataIndex: 'limite',
  },
];

class TablaStock extends React.Component {
  render() {
    return (
      <Table
        bordered
        pagination={false}
        style={{ maxWidth: 650, marginLeft: '20%', marginTop: 20 }}
        dataSource={this.props.tipo_sellos}
        columns={colums}
        rowKey={record => record.tipo_sello._id}
        rowClassName={record => {
          let retorno = 'rowTablaBlanco';
          if (record.limite != '-') {
            if (record.cantidad < record.limite) {
              retorno = 'rowTablaRojo';
            } else {
              let diferencia = record.cantidad - record.limite;
              if (diferencia < record.cantidad * 0.25) {
                retorno = 'rowTablaAmarillo';
              } else {
                retorno = 'rowTablaVerde';
              }
            }
          }
          return retorno;
        }}
        locale={{
          emptyText: 'Sin datos de stock.',
        }}
      />
    );
  }
}

export default TablaStock;
